import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type SendMissedAppointmentEmailMutationVariables = Types.Exact<{
  input: Types.SendMissedAppointmentEmailInput
}>

export type SendMissedAppointmentEmailMutation = {
  __typename?: 'Mutation'
  sendMissedAppointmentEmail: boolean
}

export const SendMissedAppointmentEmailDocument = gql`
  mutation SendMissedAppointmentEmail($input: SendMissedAppointmentEmailInput!) {
    sendMissedAppointmentEmail(input: $input)
  }
`
export type SendMissedAppointmentEmailMutationFn = ApolloReactCommon.MutationFunction<
  SendMissedAppointmentEmailMutation,
  SendMissedAppointmentEmailMutationVariables
>
export function useSendMissedAppointmentEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendMissedAppointmentEmailMutation,
    SendMissedAppointmentEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendMissedAppointmentEmailMutation,
    SendMissedAppointmentEmailMutationVariables
  >(SendMissedAppointmentEmailDocument, options)
}
export type SendMissedAppointmentEmailMutationHookResult = ReturnType<
  typeof useSendMissedAppointmentEmailMutation
>
export type SendMissedAppointmentEmailMutationResult =
  ApolloReactCommon.MutationResult<SendMissedAppointmentEmailMutation>
export type SendMissedAppointmentEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendMissedAppointmentEmailMutation,
  SendMissedAppointmentEmailMutationVariables
>
